"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_i18next_1 = require("react-i18next");

var react_web_components_1 = require("@nimles/react-web-components");

var Link_1 = require("./Link");

var getParents = function getParents(productGroup, productGroups) {
  var parents = [];

  if (!productGroup) {
    return parents;
  }

  if (productGroup.parentId) {
    var parent_1 = productGroups.find(function (pg) {
      return pg.id === productGroup.parentId;
    });
    parents = getParents(parent_1, productGroups);
  }

  parents.push(productGroup);
  return parents;
};

exports.ProductBreadcrumbs = function (_a) {
  var productGroup = _a.productGroup,
      productGroups = _a.productGroups;
  var t = react_i18next_1.useTranslation().t;

  var breadcrumbs = productGroup && productGroups && __spreadArrays([{
    name: t('prop.home'),
    to: '/'
  }], getParents(productGroup, productGroups).map(function (parent) {
    var part = {
      name: parent.name,
      to: '/' + parent.uniqueName
    };
    return part;
  }));

  return react_1.default.createElement(react_web_components_1.Breadcrumbs, {
    breadcrumbs: breadcrumbs,
    node: function node(name, to) {
      return react_1.default.createElement(Link_1.NavLink, {
        to: to
      }, name);
    }
  });
};